import axios from "axios";
import React, { useState } from "react";
import styles from "./MainSection.module.css";
import SearchBar from "./SearchBar";
import { useSearchTermContext } from "../../SearchTermContext";
const MainSection = () => {
  const [show, setShow] = useState(true);
  const [showTrans, setShowTrans] = useState("");
  const { searchTerm, setSearchTerm } = useSearchTermContext();
  const [loading, setLoading] = useState(false);

  const changeHandler = async (e) => {
    setSearchTerm(e.target.value);
  };

  const getTranscript = async () => {
    setLoading(true);
    // console.log(searchTerm);
    let videoCode;

    if (searchTerm) {
      // if (searchTerm.includes("v=") && searchTerm.includes("&")) {
      if (searchTerm.includes("v=")) {
        // videoCode = searchTerm.split("v=")[1].split("&")[0];
        videoCode = searchTerm.split("v=")[1];
      } else {
        videoCode = searchTerm.split("/")[3];
      }
    }
    console.log(videoCode);
    const res = await fetch(`https://transcriptapi.herokuapp.com/${videoCode}`);
    console.log(res);
    const data = await res.json();
    console.log(data);
    setShowTrans(data.eng_summary);
    setLoading(false);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.inputMainContainer}>
        <input type="text" onChange={changeHandler} />
        <button onClick={getTranscript}>Get Transcript</button>
      </div>
      {/* <SearchBar getTranscript={changeHandler} setShow={setShow} /> */}

      {showTrans && (
        <div className={styles.displayContainer}>
          {show ? (
            <p>{showTrans}</p>
          ) : (
            <p>Past your URL above to get your Transcript. </p>
          )}
        </div>
      )}
    </div>
  );
};

export default MainSection;
